// @flow

import Carousel from '@components/carousels/popups/DiamondAnatomy';

type TProps = {
  setPopupContent: (N: React.Node) => void
};

export const Header = 'Anatomy of a Diamond';

export function Content({ setPopupContent }: TProps) {
  return (
    <div>
      <Carousel style={{ marginTop: 10 }} setPopupContent={setPopupContent} />
    </div>
  );
}
